import { Component, OnInit } from '@angular/core';
import { GungModalService, NavbarcartComponent, NavbarCartService, SaveCartModalConfigService } from 'gung-standard';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'ref-navbarcart',
    templateUrl: './ref-navbarcart.component.html',
    styleUrls: ['./ref-navbarcart.component.scss'],
    standalone: false
})
export class RefNavbarcartComponent extends NavbarcartComponent {
  isRef = environment.projectName === 'ref';
}
